import {createAsyncThunk} from '@reduxjs/toolkit'

import {API} from '../../utils/API'

// import axios from 'axios'

export  const fetchPosts = createAsyncThunk('posts/fetchPosts', async () => {
  const {data}= await API.get(`/posts`)
return data
}
)

export const createPost = createAsyncThunk('posts/createPost', async (post) => {
    const {data} = await API.post(`/posts`, post)
    return data
})

export const updatePost = createAsyncThunk('posts/updatePost', async (post) =>{
  const {data} = await API.patch(`/posts/${post.id}`, post)
  return data
})



export const deletePost = createAsyncThunk('posts/deletePost', async (id) =>{
const {data} = await API.delete(`/posts/${id}`)
return data
})



export const likedPost = createAsyncThunk('posts/likedpost', async(id) =>{
  const {data} = await API.patch(`/posts/liked/${id}`)
  return data
})






